if(!String.prototype.a){
    String.prototype.escapeXml = function(){
        return this.replace(/[<>&'"]/g, function (c) {
            switch (c) {
                case '<': return '&lt;';
                case '>': return '&gt;';
                case '&': return '&amp;';
                case '\'': return '&apos;';
                case '"': return '&quot;';
            }
        });
    }
    String.prototype.lpad = function(len, pad) {
        if(!pad){
            return this;
        }

        let str = ''+this;
        while(str.length < len){
            str = pad + str;
        }
        return str;
    }
}